import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Select,
  SelectProps,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedState,
  useDisclosure,
  useIsFirstRender,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBriefcase2,
  IconCalendar,
  IconCheck,
  IconClipboard,
  IconEye,
  IconFileExport,
  IconSearch,
  IconStatusChange,
  IconTruckDelivery,
  IconUserCode,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, {
  memo,
  useCallback,
  useEffect,
  useState,
  useTransition,
} from "react";
import { useLocation } from "react-router-dom";
import {
  repositoryDelivery,
  styleTableMantine,
  typeGv,
} from "../../../_base/_const/_constVar";
import {
  DefaultMemoizedCell,
  DefaultMemoizedCellDate,
} from "../../../_base/_const/baseHook";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import useDynamicHeight from "../../../_base/component/Core/hookBase";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getDeliveryWorkSelect,
  getTblDmEmployeeSelect,
} from "../../../service/getSelectApi";
import CancelAssignmentView from "./CancelAssignmentView";
import DeliveryList from "./DeliveryList";
import DeliveryWarranty from "./DeliveryWarranty";
import DetailDeliveryAssignment from "./DetailDeliveryAssignment";

interface DeliveryAssignment {
  id: number;
  assignmentDate?: Date;
  fromExpectedDate?: Date;
  toExpectedDate?: Date;
  deliveryWorkId?: number;
  employee1?: number;
  employee2?: number;
  mainResponsibility1?: boolean;
  mainResponsibility2?: boolean;
  payroll1?: boolean;
  payroll2?: boolean;
  vehicleCode?: string;
  driverId?: number;
  driverName?: string;
  driverMobileNumber?: string;
  fromLocationId?: number;
  toLocationId?: number;
  distance?: number;
  distanceLevel?: number;
  distanceTotal?: number;
  partnerId?: number;
  partnerEmployeeName?: string;
  description?: string;
  type?: string;
  estimatedTime?: string;
  attribute3?: string;
  attribute4?: string;
  attribute5?: string;
  attribute6?: string;
  attribute7?: string;
  attribute8?: string;
  attribute9?: string;
  attribute10?: string;
  attribute11?: string;
  attribute12?: string;
  attribute13?: string;
  attribute14?: string;
  attribute15?: string;
  lastUpdateDate?: Date;
  createBy?: number;
  createDate?: Date;
  lastUpdateBy?: number;
  code?: string;
  deliverPriorityId?: number;
  deliveryWorkName?: string;
  empDriverName?: string;
  employee1Name?: string;
  employee2Name?: string;
  canDelete?: boolean;
  status?: string;
  transactionContent?: string;
  tblDeliveryModels: ListTblDeliveryAssignmentDetailModel[];
  warrantyServiceRequestFormModels: V_WarrantyServiceRequestFormModel[];
}

export interface ListTblDeliveryAssignmentDetailModel {
  assignmentId?: number;
  customerName?: string;
  telephoneNumber?: string;
  sourceCode?: string;
  toAddress?: string;
  transactionContent?: string;
  deliveryStatusName?: string;
  amountTotal?: number;
  amountRemaining?: number;
  description?: string;
  fromAddress?: string;
  debt?: string; // Hoặc number nếu cần kiểu số
  transactionNumber?: string;
}

export interface V_WarrantyServiceRequestFormModel {
  id: number;
  requestNum?: string;
  deliveryId: number;
  branchId?: number;
  branchName?: string;
  vendorId?: number;
  inventoryId?: number;
  requestStatusName?: string;
  requestStatus?: string;
  custId: number;
  customerName?: string;
  customerAddress?: string;
  customerPhone?: string;
  processingMethodName?: string;
  processingMethod?: string;
  createByName?: string;
  createBy?: number;
  empnameincharge?: string;
  empId?: number;
  channelName?: string;
  channel?: number;
  custPhone?: string;
  custMeeting?: string;
  meetingDate?: Date;
  content?: string;
  meetingAddress?: string;
  priority?: string;
  createDate?: Date;
  note?: string;
  address?: string;
  warrantyStatus?: number;
  isReceive?: boolean;
  errorNumber?: string;
  additionalAddress?: string;
  provinceId?: number;
  provinceName?: string;
  communeId?: number;
  communeName?: string;
  districtId?: number;
  districtName?: string;
  streetId?: number;
  streetName?: string;
  branchAddress?: string;
}

const DeliveryDispatchDV = () => {
  const height = useDynamicHeight(280);
  const [isPending, startTransition] = useTransition();
  const [valueTypeGet, setValueTypeGet] = useState<string | null>("");

  const [employeeData, setEmployeeData] = useState<ComboboxItem[]>([]);
  const [dataWorkSelect, setDataWorkSelect] = useState<ComboboxItem[]>([]);
  const dataStatus = [
    { label: "Chưa giao", value: "CHUA_GIAO" },
    { label: "Đang giao", value: "DANG_GIAO" },
    { label: "Hoàn thành", value: "HOAN_THANH" },
    { label: "Hủy", value: "HUY" },
  ];

  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<DeliveryAssignment[]>([]);
  // const [dataTemp, setDataTemp] = useState<TblDeliveryAssignment[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  //table state
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);

  const firstRender = useIsFirstRender();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState({
    startDate:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.startDate
        : new Date(
            new Date(
              new Date(new Date().setMonth(new Date().getMonth() - 1)).setHours(
                0,
                0,
                0,
                0
              )
            ).getTime() +
              7 * 60 * 60 * 1000
          )?.toISOString(),
    endDate:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.endDate
        : new Date(
            new Date(
              new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                0,
                0,
                0,
                0
              )
            ).getTime() +
              7 * 60 * 60 * 1000
          )?.toISOString(),
    code:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.code : "",
    employeeId:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.employeeId
        : "",
    vehicleCode:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.vehicleCode
        : "",
    deliveryWorkId:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.deliveryWorkId
        : "",
    status:
      firstRender && _searchJson && checkedPinSearch ? _searchJson.status : "",
    assignmentDetailCode:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.assignmentDetailCode
        : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState(
    firstRender && _searchJson && checkedPinSearch
      ? _searchJson?.keySearch
      : "",
    500
  );

  const columns = React.useMemo<MRT_ColumnDef<DeliveryAssignment>[]>(
    () => [
      // {
      //   accessorKey: "STT",
      //   header: "STT",
      //   Cell: ({ row }) => (
      //     <Text fw={500} size="12.5px">
      //       {row.index === -1 ? "" : row.index + 1}
      //     </Text>
      //   ),
      //   size: 50,
      //   enableColumnActions: false,
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   enableResizing: false,
      // },
      {
        accessorKey: "code",
        header: "Số vận đơn",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => detailAssignment(row.original.id)}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
      },
      {
        accessorKey: "status",
        header: "Trạng thái vận đơn",
        Cell: ({ row }) => (
          <Badge
            radius={"sm"}
            color={colorStatus(row.original.status ?? "")}
            bd={`1px solid ${colorStatus(row.original.status ?? "")}`}
            variant="light"
          >
            {getValueById(row.original.status ?? "", dataStatus, "label")}
          </Badge>
        ),
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
      },
      {
        accessorKey: "attribute11",
        header: "BPGV",
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
      },
      {
        accessorKey: "description",
        header: "Nội dung giao",
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "attribute8",
        header: "Công việc",
        Cell: ({ row }) => {
          // Chuyển đổi chuỗi các ID thành mảng số
          const workIds: number[] = (row.original.attribute8?.split(",") || [])
            .filter((id: string) => id.trim() !== "")
            .map((id: string) => Number(id));
          // Lọc ra các text tương ứng với id từ dataWorkSelect
          const workTexts = workIds
            .map((id) => {
              const work = dataWorkSelect.find(
                (item) => Number(item.value) === id
              );
              return work ? work.label : "";
            })
            .filter((text) => text !== "");

          return (
            <Group gap={4} wrap="wrap">
              {workTexts.map((text, index) => (
                <Badge
                  key={index}
                  size="xs"
                  color="blue"
                  variant="filled"
                  radius="sm"
                >
                  {text}
                </Badge>
              ))}
            </Group>
          );
        },
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
      },
      {
        accessorKey: "distance",
        header: "Tổng khoảng cách",
        Cell: ({ row }) => <>{(row.original.distance ?? 0) / 1000} Km</>,
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
      },
      {
        accessorKey: "employee1Name",
        header: "Nhân viên giao hàng",
        size: 250,
        //  Cell: ({ row }) => <AvatarUtils value={row.original.employee1Name} />,
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "employee2Name",
        header: "Nhân viên hỗ trợ",
        size: 250,
        //    Cell: ({ row }) => <AvatarUtils value={row.original.employee2Name} />,
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "empDriverName",
        header: "Nhân viên lái xe",
        size: 250,
        //  Cell: ({ row }) => <AvatarUtils value={row.original.empDriverName} />,
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ renderedCellValue }) => (
          <DefaultMemoizedCell value={renderedCellValue} />
        ),
      },
      {
        accessorKey: "vehicleCode",
        header: "Phương tiện giao hàng",
        Cell: ({ row }) => (
          <>{row.original.vehicleCode === "XE_MAY" ? "Xe máy" : "Ô tô"}</>
        ),
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
      },
      {
        accessorKey: "assignmentDate",
        header: "Ngày phân công",
        Cell: ({ renderedCellValue }: any) => (
          <DefaultMemoizedCellDate value={renderedCellValue} />
        ),
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 225,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 130,
        Cell: ({ row }) => (
          <ActionsCell
            id={row.original.id ?? 0}
            status={row.original.status}
            canDelete={row.original.canDelete}
          />
        ),
      },
    ],
    [dataWorkSelect]
  );

  const ActionsCell = memo(
    ({
      id,
      status,
      canDelete,
    }: {
      id: number;
      status?: string;
      canDelete?: boolean;
    }) => {
      return (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Tooltip label="Chi tiết">
            <ActionIcon
              variant="light"
              aria-label="Settings"
              color="cyan"
              onClick={async () => {
                detailAssignment(id);
              }}
            >
              <IconEye size={20} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
          {status === "CHUA_GIAO" && (
            <Tooltip label="Hủy phân công">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                disabled={!canDelete || status !== "CHUA_GIAO"}
                onClick={async () => {
                  await cancelAssignment([id]);
                }}
              >
                <IconX size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          )}
        </Box>
      );
    }
  );
  useEffect(() => {
    if (firstRender) setDefault();
  }, []);

  const setDefault = async () => {
    if (
      _searchJson &&
      _searchJson?.valueTypeGet?.length > 0 &&
      checkedPinSearch
    ) {
      setValueTypeGet(_searchJson?.valueTypeGet);
    } else {
      const res = await repositoryDelivery.get<MessageResponse<string>>(
        `/api/v1/TblDelivery/get-default-gv?type=VD`
      );
      if (res && res.httpStatusCode === 200) {
        await fetchData(res.data);

        startTransition(() => {
          setValueTypeGet(res.data);
        });
      }
    }
  };
  const colorStatus = (value: string) => {
    switch (value) {
      case "CHUA_GIAO":
        return "";
      case "HUY":
        return "red";
      case "DANG_GIAO":
        return "yellow";
      case "HOAN_THANH":
        return "green";
    }
  };

  const optionColorStatus: Record<
    "Chưa giao" | "Đang giao" | "Hoàn thành",
    string
  > = {
    "Chưa giao": "red",
    "Đang giao": "yellow",
    "Hoàn thành": "green",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorStatus[
            option.label as "Chưa giao" | "Đang giao" | "Hoàn thành"
          ]
        }
        radius="sm"
        variant="light"
        bd={`1px solid ${
          optionColorStatus[
            option.label as "Chưa giao" | "Đang giao" | "Hoàn thành"
          ]
        }`}
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  // const startCountdown = () => {
  //   if (!isCounting) {
  //     setTimeLeft(_timerDelayClick);
  //     setIsCounting(true);
  //   }
  // };

  const handleChangeSearchValue = (value: string, key: string) => {
    if (value !== "Invalid date")
      setSearch((prevData) => ({ ...prevData, [key]: value }));
    else {
      setSearch((prevData) => ({ ...prevData, [key]: "" }));
    }
  };

  const detailAssignment = async (id: string | number) => {
    try {
      modals.openConfirmModal({
        title: (
          <>
            <Title order={5}>Chi tiết phân công!</Title>
          </>
        ),
        size: "auto",
        children: (
          <DetailDeliveryAssignment id={id} onClose={setDeleteViewStatus} />
        ),
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const cancelAssignment = async (ids: (string | number)[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Hủy phân công!</Title>
            </>
          ),
          size: "550px",
          children: (
            <CancelAssignmentView idItems={ids} onClose={setDeleteViewStatus} />
          ),
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const dataEmployeeSelect = async () => {
    const get = await getTblDmEmployeeSelect();
    setEmployeeData(
      get
        ?.filter((item) => item.value != null && item.text != null)
        ?.map((item) => ({
          value: item.value,
          label: item.text,
        }))
    );
  };

  const dataDeliveryWorkSelect = async () => {
    const get = await getDeliveryWorkSelect();
    setDataWorkSelect(
      get
        .filter((item) => item.value != null && item.text != null)
        .map((item) => ({
          value: item.value,
          label: item.text,
        }))
    );
  };

  const fetchData = async (typeGet?: string) => {
    setIsLoading(true);
    //   setIsRefetching(true);
    // setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.employeeId) {
      url += `&EmployeeId=${search.employeeId}`;
    }

    if (search.vehicleCode) {
      url += `&VehicleCode=${search.vehicleCode}`;
    }

    if (search.deliveryWorkId) {
      url += `&DeliveryWorkId=${search.deliveryWorkId}`;
    }

    if (search.status) {
      url += `&Status=${search.status}`;
    }

    if (search.assignmentDetailCode) {
      url += `&AssignmentDetailCode=${search.assignmentDetailCode}`;
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      let urlPrefix = generateUrlPrefix(typeGet);
      const response = await repositoryDelivery.get(`${urlPrefix}${url}`);

      if (response && response.success) {
        let result = response.data;
        setData(result);
        startTransition(() => {
          setRowCount(response.totalCount);
          table.resetRowSelection();
        });
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      //  setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          valueTypeGet: valueTypeGet,
        })
      );
    }

    function generateUrlPrefix(typeGet?: string) {
      let urlPrefix = "/api/v1/TblDeliveryAssignment/get-list";
      const checkType = typeGet ? typeGet : valueTypeGet;
      switch (checkType) {
        case "1":
          urlPrefix = urlPrefix + "-gv";
          break;
        case "2":
          urlPrefix = urlPrefix + "-ktkt";
          break;
        case "3":
          urlPrefix = urlPrefix + "-da";
          break;
        case "4":
          urlPrefix = urlPrefix + "-kttc";
          break;
        default:
          break;
      }
      return urlPrefix;
    }
  };

  const handleExportData = async () => {
    open();
    try {
      let url = "";

      if (valueTypeGet && valueTypeGet.length > 0 && valueTypeGet !== "2") {
        url += `/api/v1/ExportExcel/export-delivery-assignment?Skip=${
          pagination?.pageIndex * pagination?.pageSize
        }&Take=${pagination.pageSize}&DeliveryDepartment=${getValueById(
          valueTypeGet ?? "",
          typeGv,
          "label"
        )}`;
      } else {
        url += `/api/v1/ExportExcel/export-delivery-assignment-ktkt?Skip=${
          pagination?.pageIndex * pagination?.pageSize
        }&Take=${pagination.pageSize}`;
      }

      if (search.startDate) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.employeeId) {
        url += `&EmployeeId=${search.employeeId}`;
      }

      if (search.vehicleCode) {
        url += `&VehicleCode=${search.vehicleCode}`;
      }

      if (search.deliveryWorkId) {
        url += `&DeliveryWorkId=${search.deliveryWorkId}`;
      }

      if (search.status) {
        url += `&Status=${search.status}`;
      }

      if (search.assignmentDetailCode) {
        url += `&AssignmentDetailCode=${search.assignmentDetailCode}`;
      }

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "thuc_hien_van_don" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    startTransition(() => {
      Promise.all([dataEmployeeSelect(), dataDeliveryWorkSelect()]);
    });
  }, []);

  useEffect(() => {
    if (valueTypeGet && valueTypeGet.length > 0) {
      fetchData();
    }
  }, [
    pagination.pageSize,
    pagination.pageIndex,
    deleteViewStatus,
    valueTypeGet,
  ]);
  const MemoizedDeliveryList = React.memo(DeliveryList);
  const MemoizedDeliveryWarranty = React.memo(DeliveryWarranty);

  const DeliveryWrapper = memo(
    ({
      warrantyServiceRequestFormModels,
      tblDeliveryModels,
    }: {
      warrantyServiceRequestFormModels: any | null;
      tblDeliveryModels: any;
    }) => {
      return warrantyServiceRequestFormModels === null ? (
        <MemoizedDeliveryList
          dataDetail={tblDeliveryModels}
          isSetHeight={false}
        />
      ) : (
        <MemoizedDeliveryWarranty
          dataDetail={warrantyServiceRequestFormModels}
        />
      );
    }
  );

  const renderDetailPanel = useCallback(
    ({ row }: { row: MRT_Row<DeliveryAssignment> }) => {
      if (!row.original) return <></>;
      return (
        <DeliveryWrapper
          key={row.id}
          tblDeliveryModels={row.original.tblDeliveryModels}
          warrantyServiceRequestFormModels={
            row.original.warrantyServiceRequestFormModels
          }
        />
      );
      // return row.original.warrantyServiceRequestFormModels === null ? (
      //   <MemoizedDeliveryList
      //     dataDetail={row.original.tblDeliveryModels}
      //     isSetHeight={false}
      //   />
      // ) : (
      //   <MemoizedDeliveryWarranty
      //     dataDetail={row.original.warrantyServiceRequestFormModels}
      //   />
      // );
    },
    [] // Không có dependency
  );

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableTopToolbar: false,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    renderDetailPanel: renderDetailPanel,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: (row) => row.original.status !== "HUY",
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "STT", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    // onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isLoading,
      //  showSkeletons: isLoading,
      //rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50"],
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
  });
  const styleGrid = { base: 6, xs: 4, sm: 3, md: 3, lg: 2 };
  return (
    <>
      <div ref={headerRef} style={{ width: "100%" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} wrap={"wrap"}>
          <_breadcrumb></_breadcrumb>
          <Flex
            gap="md"
            justify={{ sm: "flex-end", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              leftSection={
                <IconX style={{ width: rem(14), height: rem(14) }} />
              }
              //  disabled={selectIds.length < 1}
              onClick={() => {
                const idsSelect = table.getSelectedRowModel();
                console.log(idsSelect);
                if (idsSelect?.rows.length < 1) {
                  NotificationExtension.Info("Vui lòng chọn dữ liệu !");
                  return;
                }
                cancelAssignment(idsSelect.rows.map((row) => row.id));
              }}
              color="red"
            >
              Hủy phân công
            </Button>
            <Button
              leftSection={
                <IconFileExport style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => handleExportData()}
              // disabled={valueTypeGet === "3" || valueTypeGet === "4"}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Flex gap={"md"} align={"center"} wrap={"wrap"} mb={10} mt={10}>
          <Grid gutter={"xs"} w={"100%"}>
            <Grid.Col span={styleGrid}>
              <TextInput
                placeholder="Nhập từ khóa"
                leftSection={<IconSearch color="#15aabf" />}
                defaultValue={keySearch ?? ""}
                onChange={(e) => {
                  setKeySearch(e.currentTarget.value);
                }}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Từ ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                value={
                  search.startDate && search.startDate.length > 0
                    ? new Date(search.startDate)
                    : null
                }
                onChange={(e) =>
                  handleChangeSearchValue(
                    formatDateNotTimeZone(e) ?? "",
                    "startDate"
                  )
                }
                leftSection={<IconCalendar color="#15aabf" />}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Đến ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                value={
                  search.endDate && search.endDate.length > 0
                    ? new Date(search.endDate)
                    : null
                }
                onChange={(e) =>
                  handleChangeSearchValue(
                    formatDateNotTimeZone(e) ?? "",
                    "endDate"
                  )
                }
                leftSection={<IconCalendar color="#15aabf" />}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <TextInput
                placeholder="Nhập số chứng từ hoặc mã giao dịch"
                leftSection={<IconClipboard color="#15aabf" />}
                value={search.assignmentDetailCode}
                onChange={(e) =>
                  handleChangeSearchValue(
                    e.currentTarget.value,
                    "assignmentDetailCode"
                  )
                }
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Trạng thái vận đơn"
                data={dataStatus}
                leftSection={<IconStatusChange color="#15aabf" />}
                value={
                  search?.status && search?.status?.length > 0
                    ? String(search?.status)
                    : ""
                }
                searchable
                clearable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                renderOption={renderSelectOptionStatus}
                onChange={(e) => handleChangeSearchValue(e ?? "", "status")}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Nhân viên"
                data={employeeData}
                value={
                  search?.employeeId && search?.employeeId?.length > 0
                    ? String(search?.employeeId)
                    : ""
                }
                leftSection={<IconUserCode color="#15aabf" />}
                searchable
                clearable
                onChange={(e) => {
                  handleChangeSearchValue(e ?? "", "employeeId");
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Phương tiện giao hàng"
                data={[
                  { label: "Xe máy", value: "XE_MAY" },
                  { label: "Ô tô", value: "O_TO" },
                ]}
                value={
                  search?.vehicleCode && search?.vehicleCode?.length > 0
                    ? String(search?.vehicleCode)
                    : ""
                }
                clearable
                leftSection={<IconTruckDelivery color="#15aabf" />}
                onChange={(e) => {
                  handleChangeSearchValue(e ?? "", "vehicleCode");
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Công việc"
                data={dataWorkSelect}
                value={
                  search?.deliveryWorkId && search?.deliveryWorkId?.length > 0
                    ? String(search?.deliveryWorkId)
                    : ""
                }
                clearable
                leftSection={<IconBriefcase2 color="#15aabf" />}
                onChange={(e) => {
                  handleChangeSearchValue(e ?? "", "deliveryWorkId");
                }}
              />
            </Grid.Col>
            <Grid.Col span={styleGrid}>
              <Select
                placeholder="Bộ phận"
                // defaultValue={keySearch}
                leftSection={<IconSearch color="#15aabf" />}
                data={typeGv}
                value={valueTypeGet}
                onChange={setValueTypeGet}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 6, md: 6, lg: 1.25 }}>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Flex>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default DeliveryDispatchDV;
